import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onMounted, onUnmounted, ref } from 'vue';
import { debounce } from 'lodash-es';

import {
  SearchBar,
  LoaderIndicator,
  HelperViewStatus,
  DataTable,
  ButtonIconPrimary
} from '@warrenbrasil/nebraska-web';
import { EmptyHelper } from '@/modules/catalog/components';
import { registerObserver } from '@/modules/catalog/views/Products/helpers/registerObserver';
import { columns } from './columns';
import {
  IPagination,
  IProductsParams,
  IInitialPublicOffering,
  getInitialPublicOfferings
} from '@/modules/catalog/services/products';

interface Props {
  isBuilder: boolean;
}
interface EmitEvents {
  (event: 'select-product', id: string): string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InitialPublicOfferingsProducts',
  props: {
    isBuilder: { type: Boolean }
  },
  emits: ["select-product"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'select-product', id: string): string;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isBuilder: boolean;
};





const ipos = ref<IInitialPublicOffering[]>([]);
const pagination = ref<IPagination>();

const params = ref<IProductsParams>({
  pageIndex: 1,
  pageSize: 10
});

const isLoading = ref(true);
const isScrolling = ref(false);
const isSorting = ref(false);
const hasError = ref(false);
const isSearchBarHover = ref(false);
const isSearchBarFocus = ref(false);

const searchValue = ref('');
const scrollTop = ref(document.documentElement.scrollTop);

const columnsTable = computed(() => {
  return columns(pagination.value!.totalRecords);
});

const hasScrolled = computed(() => {
  return scrollTop.value >= 100;
});

const isEmpty = computed(() => {
  return ipos.value.length === 0;
});

const emptyDataType = computed(() => {
  if (searchValue.value) return 'search';
  return 'empty';
});

const scrolledButtonClass = computed(() => {
  return props.isBuilder
    ? 'initial-public-offerings-products__button builder'
    : 'initial-public-offerings-products__button';
});

const onInputChange = debounce(handleSearch, 500);

async function handleClear() {
  searchValue.value = '';
  handleSearch();
}

async function onSort(index: number, isSort: boolean, value: string) {
  const sortDirection =
    index === -1 ? undefined : isSort ? 'Ascending' : 'Descending';
  const sortField = index === -1 ? undefined : value;

  params.value = {
    ...params.value,
    pageIndex: 1,
    sortField,
    sortDirection
  };

  await fetchInitialPublicOfferings(false, false, true);
  registerObserver(fetchInitialPublicOfferings);
}

async function handleSearch() {
  params.value = {
    ...params.value,
    pageIndex: 1,
    searchTerm: searchValue.value,
    sortField: undefined,
    sortDirection: undefined
  };

  await fetchInitialPublicOfferings();
  registerObserver(fetchInitialPublicOfferings);
}

async function retry() {
  await fetchInitialPublicOfferings();
  registerObserver(fetchInitialPublicOfferings);
}

function goToTop() {
  document.documentElement.scrollTo(0, 0);
}

async function fetchInitialPublicOfferings(
  loading = true,
  scrolling = false,
  sorting = false
) {
  try {
    isLoading.value = loading;
    isScrolling.value = scrolling;
    isSorting.value = sorting;
    hasError.value = false;

    if (isScrolling.value) {
      if (!pagination.value?.nextPage) return;

      params.value = {
        ...params.value,
        pageIndex: pagination.value.nextPage
      };
    }

    const data = await getInitialPublicOfferings(params.value);

    pagination.value = data.pagination;

    if (isScrolling.value) {
      ipos.value.push(...data.items);
      return;
    }

    ipos.value = data.items;
  } catch {
    hasError.value = true;
  } finally {
    isLoading.value = false;
    isScrolling.value = false;
    isSorting.value = false;
  }
}

function handleScrollTop() {
  scrollTop.value = document.documentElement.scrollTop;
}

function handleIPOClick(ipo: IInitialPublicOffering) {
  emit('select-product', ipo.productId);

  window.history.pushState(
    {},
    '',
    `/app/#/products-view/catalog/initial-public-offering/${ipo.productId}`
  );
}

onBeforeMount(() => {
  fetchInitialPublicOfferings();
  registerObserver(fetchInitialPublicOfferings);
});

onMounted(() => {
  window.addEventListener('scroll', handleScrollTop);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScrollTop);
});

return { __sfc: true,props, emit, ipos, pagination, params, isLoading, isScrolling, isSorting, hasError, isSearchBarHover, isSearchBarFocus, searchValue, scrollTop, columnsTable, hasScrolled, isEmpty, emptyDataType, scrolledButtonClass, onInputChange, handleClear, onSort, handleSearch, retry, goToTop, fetchInitialPublicOfferings, handleScrollTop, handleIPOClick, SearchBar, LoaderIndicator, HelperViewStatus, DataTable, ButtonIconPrimary, EmptyHelper }
}

})